import type { Lang } from "../index";

export interface BlogIndexCopy {
  seo: { title: string; description: string };
  eyebrow: string;
  heading: string;
  intro: string;
  empty: string;
  /** "Read more →" affordance on each card. */
  readMore: string;
  /** Localised label for the post date — used only on the index card. */
  dateLabel?: string;
}

export interface BlogPostChromeCopy {
  back: string;
  cta: {
    eyebrow: string;
    heading: string;
    body: string;
    primary: string;
    secondary: string;
    tertiary: string;
    proof: string;
  };
}

const indexEn: BlogIndexCopy = {
  seo: {
    title: "Blog — Minuta",
    description:
      "Notes on building Minuta — secure local capture, real-time meeting copilots, and the engineering behind a no-bot, zero-retention meeting stack.",
  },
  eyebrow: "Blog",
  heading: "Notes from building Minuta",
  intro:
    "Engineering posts, product decisions, and field notes from running a secure, zero-retention meeting assistant.",
  empty: "Nothing here yet in English. Try /pt or /es while we translate.",
  readMore: "Read more →",
};

const indexPt: BlogIndexCopy = {
  seo: {
    title: "Blog — Minuta",
    description:
      "Notas de quem constrói o Minuta — captura local segura, copiloto em reuniões em tempo real e a engenharia por trás de um stack de transcrição sem bot e com retenção zero.",
  },
  eyebrow: "Blog",
  heading: "Notas de quem constrói o Minuta",
  intro:
    "Posts de engenharia, decisões de produto e relatos de quem desenvolve um assistente de reunião seguro com retenção zero.",
  empty: "Nada por aqui em português ainda. Tente /en enquanto traduzimos.",
  readMore: "Continuar lendo →",
};

const indexEs: BlogIndexCopy = {
  seo: {
    title: "Blog — Minuta",
    description:
      "Notas de quien construye Minuta — captura local segura, copiloto en reuniones en tiempo real y la ingeniería detrás de un stack de transcripción sin bot y con retención cero.",
  },
  eyebrow: "Blog",
  heading: "Notas de quien construye Minuta",
  intro:
    "Posts de ingeniería, decisiones de producto y notas de campo sobre desarrollar un asistente de reunión seguro con retención cero.",
  empty: "Aún nada por aquí en español. Prueba /en mientras traducimos.",
  readMore: "Seguir leyendo →",
};

export const blogIndexCopy: Record<Lang, BlogIndexCopy> = {
  en: indexEn,
  pt: indexPt,
  es: indexEs,
};

export const blogPostChromeCopy: Record<Lang, BlogPostChromeCopy> = {
  en: {
    back: "← Back to all posts",
    cta: {
      eyebrow: "Try Minuta in your next call",
      heading: "Get real-time help before the silence costs you.",
      body:
        "Start the full 7-day trial, download the desktop app, and run the copilot beside your next meeting in English, Portuguese, or Spanish. No credit card required.",
      primary: "Start free trial",
      secondary: "Download app",
      tertiary: "See the copilot",
      proof: "7 days with full access · macOS and Windows · secure zero-retention cloud APIs",
    },
  },
  pt: {
    back: "← Voltar para todos os posts",
    cta: {
      eyebrow: "Teste o Minuta na próxima call",
      heading: "Receba ajuda em tempo real antes do silêncio custar caro.",
      body:
        "Comece 7 dias com acesso completo, baixe o app desktop e rode o copiloto ao lado da sua próxima reunião em inglês, português ou espanhol. Sem cartão de crédito.",
      primary: "Começar trial grátis",
      secondary: "Baixar app",
      tertiary: "Ver o copiloto",
      proof: "7 dias com acesso completo · macOS e Windows · APIs de nuvem seguras com retenção zero",
    },
  },
  es: {
    back: "← Volver a todos los posts",
    cta: {
      eyebrow: "Prueba Minuta en tu próxima llamada",
      heading: "Recibe ayuda en tiempo real antes de que el silencio cueste caro.",
      body:
        "Empieza 7 días con acceso completo, descarga la app de escritorio y usa el copiloto junto a tu próxima reunión en inglés, portugués o español. Sin tarjeta de crédito.",
      primary: "Empezar prueba gratis",
      secondary: "Descargar app",
      tertiary: "Ver el copiloto",
      proof: "7 días con acceso completo · macOS y Windows · APIs de nube seguras con retención cero",
    },
  },
};
